import IframeResizer from 'iframe-resizer-react';
import React from 'react';
import { ErrorState } from '../CommonComponents/ErrorState/ErrorState';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Loading } from '../CommonComponents/OPL/Loading/Loading';
import { NoAccess } from './components/NoAccess/NoAccess';
import { Tab, Tabs } from './components/Tabs/Tabs';
import { useRouteParams } from './hooks/useRouteParams';
import { useOrionTrading } from './useOrionTrading';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';

interface Props {
  clientId: string;
}

export const OrionTrading: React.FC<Props> = ({ clientId }) => {
  const { data, refetch, isLoading, isError } = useOrionTrading({ clientId });

  const { tabSlug } = useRouteParams();

  useDocumentTitle('Trading');

  if (isLoading) {
    return (
      <Box height="100%" display="flex" alignItems="center" justifyContent="center">
        <Loading size="large" />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box height="100%" display="flex" alignItems="center" justifyContent="center">
        <ErrorState onRetry={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  if (!data.isTradingAllowed) {
    return <NoAccess />;
  }

  const { allocationsScreenUrl, tradesScreenUrl, confirmationsScreenUrl } = data;

  const tabList: Tab[] = [
    {
      slug: 'allocations',
      label: 'Allocations',
      url: allocationsScreenUrl,
    },
    {
      slug: 'trades',
      label: 'Trades',
      url: tradesScreenUrl,
    },
    {
      slug: 'confirmations',
      label: 'Confirmations',
      url: confirmationsScreenUrl,
    },
  ];

  const validTabs = tabList.filter(tab => tab.url !== null);

  const iframeUrl = validTabs.find(tab => tab.slug === tabSlug)?.url;

  return (
    <Box height="100%" display="flex" flexDirection="column">
      <Tabs tabs={validTabs} selected={tabSlug} clientId={clientId} />

      {iframeUrl && (
        <IframeResizer
          src={iframeUrl}
          checkOrigin={false}
          frameBorder="0"
          style={{ width: '1px', minWidth: '100%' }}
        />
      )}
    </Box>
  );
};
